export enum SearchEvent {
    FILTER_GAMES = "Filter",
    TOGGLE_SEARCH = "ToggleSearch",
    SEARCH = "SearchQuery",
    SEARCH_EMPTY = "SearchQueryEmpty",
    SEARCH_FAILURE = "SearchFailure",
    SEARCH_RESULT_SUCCESS = "SearchResultSuccess"
  }
  